// extracted by mini-css-extract-plugin
module.exports = {"checkoutButton":"YJ9VG"};